import { StyleSheetManager } from 'styled-components';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { createRoot } from 'react-dom/client';
import React from 'react';
import { Provider as JotaiProvider } from 'jotai';
import CustomParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';
import {
  NotificationProvider,
  DialogProvider,
  shouldForwardProp,
} from '@idk-web/core-ui';
import { ThemeProvider } from '@/styled-components/theme';
import { store } from '@/state/store';
import SentryProvider from '@/sentry/provider';
import * as Sentry from '@/sentry';
import * as I18n from '@/i18n';
import { EventListenerProvider } from '@/hooks/portal/ws/useEventListener';
import App from '@/App';
import '@/client';

dayjs.extend(CustomParseFormat);

Sentry.initialize();
I18n.initialize();

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const appRoot = document.getElementById('app-root')!;

createRoot(appRoot).render(
  <React.StrictMode>
    <HelmetProvider>
      <JotaiProvider store={store}>
        <SentryProvider>
          <StyleSheetManager shouldForwardProp={shouldForwardProp}>
            <ThemeProvider>
              <BrowserRouter>
                <NotificationProvider>
                  <DialogProvider>
                    <EventListenerProvider>
                      <App />
                    </EventListenerProvider>
                  </DialogProvider>
                </NotificationProvider>
              </BrowserRouter>
            </ThemeProvider>
          </StyleSheetManager>
        </SentryProvider>
      </JotaiProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
